import {
    BasePortalOutlet, CdkPortalOutlet, ComponentPortal, TemplatePortal,
} from '@angular/cdk/portal';
// Import external
import { Component, ComponentRef, EmbeddedViewRef, ViewChild } from '@angular/core';

@Component({
    selector: 'syn-drawer',
    styleUrls: ['./drawer.component.scss'],
    templateUrl: 'drawer.component.html'
})
export class DrawerComponent extends BasePortalOutlet {

    @ViewChild(CdkPortalOutlet, {static: true}) portal: CdkPortalOutlet;

    public isOpened = false;

    attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T> {
        return this.portal.attachComponentPortal(portal);
    }

    attachTemplatePortal<C>(portal: TemplatePortal<C>): EmbeddedViewRef<C> {
        return this.portal.attachTemplatePortal(portal);
    }
}
